import { useContext, useEffect, useState } from "react";
import useConfig from "../../../hooks/use-config";
import EventEmitter from "../../../utils/EventEmitter";
import { ChatAudio } from "../../../audio";
import Socket from "../../../providers/Socket";
import useTranslation from "../../../hooks/use-translation";
const Chat = (props) => {
    const { render } = props;
    const config = useConfig();
    const [counter, setCounter] = useState(0);
    const { socket } = useContext(Socket);
    const { translate } = useTranslation();
    useEffect(() => {
        if (!socket)
            return;
        EventEmitter.subscribe("unread-history-rooms", (data) => {
            let count = 0;
            data.map((chat) => {
                count += chat.unread;
            });
            setCounter(count);
        });
        EventEmitter.subscribe("message.notify", (data) => {
            ChatAudio.getInstance().play();
            socket === null || socket === void 0 ? void 0 : socket.emit('history-flat-rooms', { type: 'unread', limit: 1000 }, function (data) {
                EventEmitter.emit('unread-history-rooms', data);
            });
        });
        socket === null || socket === void 0 ? void 0 : socket.emit('history-flat-rooms', { type: 'unread', limit: 100000 }, function (data) {
            EventEmitter.emit('unread-history-rooms', data);
        });
        socket.on("seen", (pid, oid, uid, mid) => {
            socket === null || socket === void 0 ? void 0 : socket.emit('history-flat-rooms', { type: 'unread', limit: 100000 }, function (data) {
                EventEmitter.emit('unread-history-rooms', data);
            });
        });
        return () => {
            EventEmitter.unsubscribe("message.notify");
            EventEmitter.unsubscribe("unread-history-rooms");
            socket.off("seen");
        };
    }, [socket]);
    useEffect(() => {
        if (!socket)
            return;
        EventEmitter.subscribe("counter.decrease", (count) => {
            setCounter((currentCounter) => {
                return currentCounter - count;
            });
        });
        return () => {
            EventEmitter.unsubscribe("counter.decrease");
        };
    }, [socket, counter, setCounter]);
    return render(counter);
};
export default Chat;
